import React, { useState } from 'react';
import './DestinationGallery.css';

function DestinationGallery({ destination }) {
  const [selectedImage, setSelectedImage] = useState(0);

  return (
    <section className="destination-gallery-section">
      <div className="destination-gallery-container">
        <h2 className="destination-gallery-title">Photo Gallery</h2>
        <div className="destination-gallery-content">
          <div className="gallery-main-image">
            <img 
              src={destination.images[selectedImage]} 
              alt={destination.name}
              className="gallery-main-img"
            />
          </div>
          <div className="gallery-thumbnails">
            {destination.images.map((image, index) => (
              <div
                key={index}
                className={`gallery-thumbnail ${selectedImage === index ? 'active' : ''}`}
                onClick={() => setSelectedImage(index)}
              >
                <img 
                  src={image} 
                  alt={`${destination.name} ${index + 1}`}
                  className="thumbnail-img"
                />
              </div>
            ))}
          </div>
          {destination.images.length > 0 && (
            <p className="gallery-note">
              {destination.images.length} {destination.images.length === 1 ? 'photo' : 'photos'} available
            </p>
          )}
        </div>
      </div>
    </section>
  );
}

export default DestinationGallery;

